/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeReportChooserCtrl
 */
angular.module('mercury.modules.stock.stocktakereport')
.controller('StockStocktakeReportChooserCtrl', ["dialog", "$filter", "$q", "$scope", "Stocktakes", "$state", "title", function(dialog, $filter, $q, $scope, Stocktakes, $state, title) {
  title.set('Stocktake Report');

  $scope.stocktakes = Stocktakes.getArchive(
    moment().subtract(12, 'months').format(),
    moment().format()
  );

  $scope.stocktakeTypes = Stocktakes.stocktakeTypes();
  $scope.stocktakeTypes.then(function(result) {
    $scope.stocktakeTypes = result;
  });

  $scope.activeType = null;
  $scope.startStocktake = null;
  $scope.endStocktake = null;

  $q.all([$scope.stocktakeTypes, $scope.stocktakes.$promise])
  .then(function() {
    if ($scope.stocktakes.length === 0) {
      $scope.activeType = $scope.stocktakeTypes[0].id;
    }

    // Set the inital ActiveType as the first one with at least 2 stocktakes avaliable.
    angular.forEach($scope.stocktakeTypes, function(type, index) {
      if ($scope.activeType === null && $filter('filter')($scope.stocktakes, {templateId: type.id}).length > 1) {
        $scope.activeType = type.id;
      } else if ($filter('filter')($scope.stocktakes, {templateId: type.id}).length === 0 && type.isDeleted) {
        // If the template was deleted and there are no stocktakes, there no need to show it as an option.
        $scope.stocktakeTypes.splice(index, 1);
      }
    });

    $scope.typeChanged();
  });

  $scope.typeChanged = function() {
    $scope.enoughData = $filter('filter')($scope.stocktakes, {templateId: $scope.activeType}).length > 1;
  };

  $scope.view = function() {
    $scope.stocktakeReportForm.$setSubmitted();
    if ($scope.stocktakeReportForm.$invalid) {
      return;
    }

    $state.go('Stock.StocktakeReportView', {startStocktake: $scope.startStocktake, endStocktake: $scope.endStocktake});
  };

  $scope.formatOption = function(stocktake) {
    return moment(stocktake.datestampCompleted).format('ddd Do MMM') + ' - ' + stocktake.title;
  };
}]);
